import { EmailConfirmationState } from '@pages/email-confirmation/store/states/email-confirmation.state';

export const emailConfirmationState = [EmailConfirmationState];
